const Settings = {
  CARROT_BACKEND_URL: window.env?.CARROT_BACKEND_URL,
  CARROT_BACKEND_ADMIN_URL: window.env?.CARROT_BACKEND_ADMIN_URL,
  SENTRY_URL: window.env?.SENTRY_URL,
  HEAP_ENV_ID: window.env?.HEAP_ENV_ID,
  IVF_TREATMENT_OPTIONS_URL: window.env?.IVF_TREATMENT_OPTIONS_URL,
  CONTENTFUL_SPACE_ID: window.env?.CONTENTFUL_SPACE_ID,
  CONTENTFUL_ACCESS_TOKEN: window.env?.CONTENTFUL_ACCESS_TOKEN,
  CONTENTFUL_PREVIEW_MODE: window.env?.CONTENTFUL_PREVIEW_MODE,
  ZENDESK_GUIDE: window.env?.ZENDESK_GUIDE
}

export default Settings
